/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { ListByPlatformUploadStatusQueryResponse, ListByPlatformUploadStatusPathParams } from "../models/ListByPlatformUploadStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listByPlatformUploadStatus } from "../axios/listByPlatformUploadStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listByPlatformUploadStatusQueryKey = (platform: ListByPlatformUploadStatusPathParams["platform"]) => ["social-export-api", { url: '/upload/status/all/:platform', params: {platform:platform} }] as const

export type ListByPlatformUploadStatusQueryKey = ReturnType<typeof listByPlatformUploadStatusQueryKey>

export function listByPlatformUploadStatusQueryOptions(platform: ListByPlatformUploadStatusPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listByPlatformUploadStatusQueryKey(platform)
        return queryOptions<ListByPlatformUploadStatusQueryResponse, ResponseErrorConfig<Error>, ListByPlatformUploadStatusQueryResponse, typeof queryKey>({
         enabled: !!(platform),
         queryKey,
         queryFn: async ({ signal }) => {
            return listByPlatformUploadStatus(platform, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get uploads status
 * {@link /upload/status/all/:platform}
 */
export function useListByPlatformUploadStatus<TData = ListByPlatformUploadStatusQueryResponse, TQueryData = ListByPlatformUploadStatusQueryResponse, TQueryKey extends QueryKey = ListByPlatformUploadStatusQueryKey>(platform: ListByPlatformUploadStatusPathParams["platform"], options: 
{
  query?: Partial<QueryObserverOptions<ListByPlatformUploadStatusQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? listByPlatformUploadStatusQueryKey(platform)
         

         const query = useQuery({
          ...listByPlatformUploadStatusQueryOptions(platform, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}